export const FORMATION_TASK_TYPES = ['llc_formation', 'corp_formation'];

// Formation statuses where the customer still owes us post-purchase data.
export const FORMATION_POST_PURCHASE_OUTSTANDING_STATUSES = ['incomplete', 'action_req'];

/**
 * Finds a formation task still waiting on the customer, if there is one. A formed
 * entity can still owe formation data, so this reads the task, not formationStatus.
 * @param {Array} orderTasks - Order tasks with status
 * @returns {object | undefined} The outstanding formation task
 */
export function getOutstandingFormationTask(orderTasks) {
  return orderTasks.find(
    (task) =>
      FORMATION_TASK_TYPES.includes(task.type) && FORMATION_POST_PURCHASE_OUTSTANDING_STATUSES.includes(task.status),
  );
}

/**
 * The service code a task's redirect route is keyed by — its own type, except a Delaware
 * corp formation, which completes through share setup rather than the generic corp route.
 * @param {object} task - Order task item
 * @returns {string} Service code to resolve a redirect for
 */
export function getRedirectServiceCode(task) {
  if (task.type === 'corp_formation' && task.jurisdictionCode === 'DE') {
    return 'corp_shares_setup';
  }
  return task.type;
}
